import { Link } from "react-router-dom";
import { Icon } from "@project/ui";
import { DashboardBackLink } from "@apps/dashboard/components/layout/DashboardBackLink";
import { DASHBOARD_PAGE_CONTAINER } from "@apps/dashboard/components/layout/dashboard-page-layout";
import { useI18n } from "@apps/dashboard/contexts/I18nContext";
import { dashboardPaths } from "@apps/dashboard/lib/routes";

export default function SupportPage(): JSX.Element {
  const { t } = useI18n();

  return (
    <div className={DASHBOARD_PAGE_CONTAINER}>
      <DashboardBackLink to={dashboardPaths.settings}>{t("dashboardUi.settingsHub.backToAccount")}</DashboardBackLink>
      <h1 className="font-headline text-2xl font-bold tracking-tight text-primary">{t("dashboardUi.pages.support")}</h1>
      <p className="mt-2 font-body text-body-md text-on-surface-variant">{t("dashboardUi.supportPage.subtitle")}</p>

      <p className="mt-8 font-body text-body-md leading-relaxed text-on-surface">{t("dashboardUi.supportPage.intro")}</p>

      <section className="mt-10 rounded-2xl border border-outline-variant/15 bg-surface-container-lowest p-8 shadow-sm">
        <div className="flex items-start gap-4">
          <div className="flex size-12 shrink-0 items-center justify-center rounded-xl bg-secondary/10 text-secondary">
            <Icon name="KeyRound" className="size-6" strokeWidth={1.5} />
          </div>
          <div>
            <h2 className="font-headline text-lg font-bold text-on-surface">{t("dashboardUi.supportPage.forgotTitle")}</h2>
            <p className="mt-2 font-body text-body-md text-on-surface-variant">{t("dashboardUi.supportPage.forgotBody")}</p>
            <Link
              to={dashboardPaths.forgotPassword}
              className="mt-4 inline-flex items-center gap-2 font-semibold text-primary hover:underline"
            >
              {t("dashboardUi.supportPage.forgotCta")}
              <Icon name="ChevronRight" className="size-4" strokeWidth={1.5} aria-hidden />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
